/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/54372731
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import dropLast from 'ramda/src/dropLast';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import keys from 'ramda/src/keys';
import length from 'ramda/src/length';
import propEq from 'ramda/src/propEq';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import { toast } from 'react-toastify';
import queryString from 'query-string';
import DatePicker from '@components/@core/DatePicker';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import EditDropdown from '@components/EditDropdown';
import Pagination from '@components/@core/Pagination';
import AppActions from '~/actions/app';
import DevelopActions from '~/actions/develop';
import ManageActions from '~/actions/manage';
import { exportCsv } from '~/services/util-excel';
import withNavigate from '~/hocs/withNavigate';
import Employees from './Employees';
import Careers from './Careers';
import { CareerPdf } from './CareerPdf';

const moment = extendMoment(originalMoment);

class Career extends Component {
    constructor(props) {
        super(props);

        const dateStart = props.location.state?.dateStart || moment().startOf('month').format('YYYY-MM-DD');
        const dateEnd = props.location.state?.dateEnd || moment().endOf('month').format('YYYY-MM-DD');
        const curPage = props.location.state?.curPage || 1;
        const perPage = props.location.state?.perPage || 10;

        const company = props.company[0] < 0 ? props.companies[0] : find(propEq('id', props.company[0]), props.companies);
        const jobRoles = company?.job_roles || [];

        this.state = {
            careers: null,
            curPage,
            totalPage: 1,
            perPage,
            company,
            user: {},
            userIds: [],
            jobRoles,
            activeTab: queryString.parse(props.location.search)?.active || 'employees',
            dateStart,
            dateEnd,
        };
    }

    componentDidMount() {
        const { activeTab, company, userIds, curPage, perPage, dateStart, dateEnd } = this.state;
        this.handleFetchCareers(activeTab, company.id, userIds, perPage, curPage, dateStart, dateEnd);
    }

    handleFetchCareers = (type, company_id, userIds, per_page, page, date_start, date_end) => {
        this.props.getCareerReports(type, userIds, { company_id, page, per_page, date_start, date_end });
    };

    handleSelectTab = (tab) => {
        const { activeTab, company, userIds, curPage, perPage, dateStart, dateEnd } = this.state;
        if (activeTab !== tab) {
            this.handleFetchCareers(tab, company?.id, userIds, perPage, curPage, dateStart, dateEnd);
            this.setState({ activeTab: tab });
            this.props.navigate({ search: `?active=${tab}` });
        }
    };

    handleFilter = (type, e) => {
        const { activeTab, company, userIds, curPage, perPage, dateStart, dateEnd } = this.state;
        if (type === 'company') {
            this.handleFetchCareers(activeTab, e[0].id, userIds, perPage, curPage, dateStart, dateEnd);
            this.setState({ company: e[0] });
        } else if (type === 'employee') {
            if (e.length < 1) {
                this.handleFetchCareers(activeTab, company?.id, [], perPage, curPage, dateStart, dateEnd);
                this.setState({ userIds: [] });
            } else {
                let _userIds = [];
                e.forEach((item) => _userIds.push(item.id));
                this.handleFetchCareers(activeTab, company?.id, _userIds, perPage, curPage, dateStart, dateEnd);
                this.setState({ userIds: _userIds });
            }
        }
    };

    handlePage = (curPage) => {
        const { activeTab, company, userIds, perPage, dateStart, dateEnd } = this.state;
        this.handleFetchCareers(activeTab, company?.id, userIds, perPage, curPage, dateStart, dateEnd);
        this.setState({ curPage });
    };

    handlePer = (perPage) => {
        const { activeTab, company, userIds, dateStart, dateEnd } = this.state;
        this.handleFetchCareers(activeTab, company?.id, userIds, perPage, 1, dateStart, dateEnd);
        this.setState({ perPage, curPage: 1 });
    };

    handleMenu = (event, item, user) => {
        const { company, activeTab, dateStart, dateEnd, curPage, perPage } = this.state;
        const type = dropLast(1, activeTab);

        switch (event) {
            case 'edit career':
                this.props.toggleModal({
                    type: 'Quick Edit',
                    data: {
                        before: { template: item, type: 'careers', from: 'instance', companyId: company?.id },
                    },
                    callBack: {
                        onDelete: () => this.handleDeleteProgram(item),
                    },
                });
                break;
            case 'assign career':
                this.props.toggleModal({
                    type: 'Assign Program',
                    data: {
                        before: {
                            modules: [],
                            disabled: ['certifications'],
                            assignees: [user.id],
                            companyId: company?.id,
                            after: {
                                type: 'FETCHCAREERREPORTS_REQUEST',
                                target: activeTab,
                                userIds: [],
                                payload: {
                                    company_id: company?.id,
                                    per_page: perPage,
                                    page: curPage,
                                    date_start: dateStart,
                                    date_end: dateEnd,
                                },
                            },
                        },
                    },
                });
                break;
            case 'view career': {
                if (isNil(item)) {
                    toast.warn('No Career assigned to the user', {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    const programId = item.id;
                    const route =
                        type === 'employee'
                            ? {
                                  pathname: `/hcm/report-careers/${type}/${user.id}/view`,
                                  state: { dateStart, dateEnd, curPage, perPage },
                              }
                            : `/hcm/report-careers/${type}/${item.id}/${event}`;
                    this.props.getCareerProgram(programId, route);
                }
                break;
            }
            case 'save actuals': {
                if (item.quotas.length === 0) {
                    toast.warn(`This program doesn't have any QUOTAs that you can update!`, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                } else {
                    this.props.toggleModal({
                        type: 'Save Actuals',
                        data: {
                            before: {
                                user,
                                type: 'programs',
                                after: {
                                    type: 'FETCHCAREERREPORTS_REQUEST',
                                    target: activeTab,
                                    userIds: [],
                                    payload: {
                                        company_id: company?.id,
                                        per_page: perPage,
                                        page: curPage,
                                        date_start: dateStart,
                                        date_end: dateEnd,
                                    },
                                },
                            },
                        },
                    });
                }
                break;
            }
            default:
                break;
        }
    };

    handleDeleteProgram = (program) => {
        const { activeTab, company, curPage, perPage, dateStart, dateEnd } = this.state;
        const payload = {
            event: 'delete',
            data: { program: { id: program.id } },
            after: {
                type: 'FETCHCAREERREPORTS_REQUEST',
                target: activeTab,
                userIds: [],
                payload: {
                    company_id: company?.id,
                    per_page: perPage,
                    page: curPage,
                    date_start: dateStart,
                    date_end: dateEnd,
                },
            },
        };
        this.props.deleteProgram(payload);
    };

    handleDate = (e) => {
        const { activeTab, company, userIds, curPage, perPage } = this.state;
        const dateStart = moment(e.start).format('YYYY-MM-DD');
        const dateEnd = moment(e.end).format('YYYY-MM-DD');
        this.handleFetchCareers(activeTab, company?.id, userIds, perPage, curPage, dateStart, dateEnd);
        this.setState({ dateStart, dateEnd });
    };

    handleExcelReport = () => {
        const { careerReports } = this.props;
        this.handlePer(careerReports.total);
        this.props.toggleModal({
            type: 'Confirm',
            data: {
                before: {
                    title: 'Confirm',
                    body: 'Would you like to download this reports data to excel?',
                },
            },
            callBack: {
                onYes: () => {
                    this.handleExcel();
                },
            },
        });
    };

    handleExcel = () => {
        const { activeTab, jobRoles } = this.state;
        const { careerReports } = this.props;
        const { users, programs } = careerReports;
        let data = [];
        let key = [];
        if (activeTab === 'employees') {
            users.forEach((item) => {
                const { profile, stats } = item;
                let currentCareer = stats.open_careers[0];
                if (stats.open === 0 && stats.completed !== 0) {
                    currentCareer = stats.completed_careers[0];
                }
                const title = currentCareer?.title || 'No Program Assigned';
                const name = isNil(profile) ? '' : `${profile.first_name} ${profile.last_name}`;
                const careerRole = find(propEq('id', currentCareer?.job_role_id), jobRoles) || null;
                const jobTitle = careerRole?.name || '';
                const level = isNil(currentCareer) ? 'N/A' : `(${currentCareer.level}/${isNil(currentCareer.data) || isNil(currentCareer.data.levels) ? 1 : length(keys(currentCareer.data.levels))})`;
                const started = isNil(currentCareer)
                    ? 'N/A'
                    : moment
                          .utc(currentCareer.started_at || currentCareer.created_at)
                          .local()
                          .format('MMM DD, YYYY');
                const end = isNil(currentCareer) || isNil(currentCareer.end_estimate) ? 'N/A' : moment.utc(item.program.end_estimate).local().format('MMM DD, YYYY');
                let completed = 0;
                if (!isNil(currentCareer)) {
                    const currentStats = currentCareer.stats;
                    const { courses, quotas } = currentStats;
                    const totals = (quotas?.total || 0) + (courses?.total || 0);
                    const completes = (quotas?.complete || 0) + (courses?.complete || 0);
                    completed = totals === 0 ? 100 : ((completes * 100) / totals).toFixed(2);
                }
                const employeeData = {
                    Employee: name,
                    Career: title,
                    Level: `${jobTitle} ${level}`,
                    Started: started,
                    'Est. Compl.': end,
                    Completed: `${completed}%`,
                };
                data.push(employeeData);
            });
            key = ['Employee', 'Career', 'Level', 'Started', 'Est. Compl.', 'Completed'];
        } else {
            programs.map((program) => {
                const openEmployees =
                    program.stats.open_employees?.map((e) => {
                        const { profile } = e;
                        return { name: `${profile.first_name} ${profile.last_name}` };
                    }) || [];
                const completedEmployees =
                    program.stats.completed_employees?.map((e) => {
                        const { profile } = e;
                        return { name: `${profile.first_name} ${profile.last_name}` };
                    }) || [];
                let openEmpolyeesName = [];
                openEmployees.forEach((e) => {
                    openEmpolyeesName.push(e.name);
                });
                let completedEmployeesName = [];
                completedEmployees.forEach((e) => {
                    completedEmployeesName.push(e.name);
                });
                const careerData = {
                    Careers: program.title,
                    Open: program.stats.open,
                    'Open Employees': isEmpty(openEmpolyeesName) ? 'No employee' : openEmpolyeesName.join(', '),
                    Completed: program.stats.completed,
                    'Completed Employees': isEmpty(completedEmployeesName) ? 'No employee' : completedEmployeesName.join(', '),
                };
                data.push(careerData);
            });

            key = ['Careers', 'Open', 'Open Employees', 'Completed', 'Completed Employees'];
        }
        exportCsv(data, key, `Career-Reports-${activeTab}`, true);
        this.handlePer(25);
    };

    handleSelectMenu = (e) => {
        const { activeTab, dateStart, dateEnd, jobRoles } = this.state;
        const { careerReports } = this.props;
        const { users, programs } = careerReports;
        const date = moment.range(dateStart, dateEnd);

        switch (e) {
            case 'print':
                CareerPdf({ users, programs, jobRoles, date, tab: activeTab });
                break;
            case 'export':
                this.handleExcelReport();
                break;
            default:
                break;
        }
    };

    render() {
        const { userRole, careerReports } = this.props;
        const { activeTab, jobRoles, dateStart, dateEnd, curPage, perPage } = this.state;
        const { last_page, users, programs } = careerReports;
        const date = moment.range(dateStart, dateEnd);
        const dotsMenu = ['Print', 'Export'];
        return (
            <ErrorBoundary className="mng-career-list">
                <Filter onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex ai-center mb-3">
                        <div className="dsl-b22 bold d-flex-1">Health Plan</div>
                        <DatePicker calendar="range" dataCy="careerReportFilterDate" append="caret" format="MMM D" align="right" as="span" value={date} onSelect={this.handleDate} />
                        <EditDropdown className="ml-3" options={dotsMenu} onChange={this.handleSelectMenu} />
                    </div>
                    <Tabs id="careers-report" data-cy="careerTabText" defaultActiveKey="employees" activeKey={activeTab} onSelect={this.handleSelectTab}>
                        <Tab key="employees" eventKey="employees" title="Employees" data-cy="careerEmployeeTabContent">
                            <Employees data={users} dataCy="employeeList" role={userRole} jobRoles={jobRoles} navigate={this.props.navigate} location={this.props.location} onMenu={this.handleMenu} />
                        </Tab>
                        <Tab key="careers" eventKey="careers" title="Careers" data-cy="careerCareersTabContent">
                            <Careers data={programs} role={userRole} onMenu={this.handleMenu} />
                        </Tab>
                    </Tabs>
                    {users.length >= perPage && <Pagination current={curPage} per={perPage} pers={[10, 25, 50, 'all']} total={last_page} onChange={this.handlePage} onPer={this.handlePer} />}
                </div>
            </ErrorBoundary>
        );
    }
}

Career.propTypes = {
    userRole: PropTypes.number,
    company: PropTypes.array.isRequired,
    companies: PropTypes.array.isRequired,
    careerReports: PropTypes.shape({
        type: PropTypes.string,
        users: PropTypes.array,
        programs: PropTypes.array,
        page: PropTypes.number,
        per_page: PropTypes.number,
        last_page: PropTypes.number,
        total: PropTypes.number,
    }),
    getCareerReports: PropTypes.func,
    getCareerProgram: PropTypes.func,
    deleteProgram: PropTypes.func,
};

Career.defaultProps = {
    userRole: 2,
    company: [],
    careerReports: {
        type: 'employees',
        users: [],
        programs: [],
        page: 1,
        per_page: 25,
        last_page: 1,
        total: 1,
    },
    getCareerReports: () => {},
    getCareerProgram: () => {},
    deleteProgram: () => {},
};

const mapStateToProps = (state) => ({
    userRole: state.app.app_role_id,
    company: state.app.selectedCompany,
    companies: state.app.companies,
    careerReports: state.manage.careerReport,
});

const mapDispatchToProps = (dispatch) => ({
    getCareerReports: (target, userIds, payload) => dispatch(ManageActions.fetchcareerreportsRequest(target, userIds, payload)),
    getCareerProgram: (programId, route) => dispatch(ManageActions.getcareerprogramRequest(programId, route)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
    deleteProgram: (e) => dispatch(DevelopActions.programeventRequest(e)),
});

const CareerWithNavigate = withNavigate(Career);

export default connect(mapStateToProps, mapDispatchToProps)(CareerWithNavigate);
